import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Text } from '@beef/ui-kit';
import { isEmpty } from 'lodash';
import { CHECK_HOUSE_CONNECTION_STATUS, popupSteps } from "./constants";
export var buildCompleteAddressString = function buildCompleteAddressString(_ref) {
  var street_with_type = _ref.street_with_type,
    house_type = _ref.house_type,
    house = _ref.house,
    block_type = _ref.block_type,
    block = _ref.block,
    flat_type = _ref.flat_type,
    flat = _ref.flat;
  return [street_with_type && "".concat(street_with_type), house && "".concat(house_type || '', " ").concat(house), block && "".concat(block_type || '', " ").concat(block), flat && "".concat(flat_type || '', " ").concat(flat)].filter(Boolean).join(', ');
};
export var mapDropdownOptions = function mapDropdownOptions(options) {
  return options === null || options === void 0 ? void 0 : options.filter(function (option) {
    return !isEmpty(option);
  }).slice(0, 3).map(function (option) {
    var address = buildCompleteAddressString(option);
    var cityOrSettlement = option.settlement_with_type || option.city_with_type;
    return _objectSpread(_objectSpread({}, option), {}, {
      label: address,
      id: "".concat(option.house_fias_id, ", ").concat(address),
      value: "".concat(cityOrSettlement, ", ").concat(address),
      additionalInfo: /*#__PURE__*/React.createElement(Text, {
        color: "grey40",
        size: "size5-r-s",
        tagType: "div",
        "data-t-id": "store-common"
      }, cityOrSettlement)
    });
  });
};
export var mapCheckConnectionResponse = function mapCheckConnectionResponse(_ref2) {
  var status = _ref2.status,
    isHighSpeed = _ref2.isHighSpeed,
    _ref2$isHighSpeedTari = _ref2.isHighSpeedTariff,
    isHighSpeedTariff = _ref2$isHighSpeedTari === void 0 ? false : _ref2$isHighSpeedTari;
  if (status === CHECK_HOUSE_CONNECTION_STATUS.IsAvailable && isHighSpeedTariff) {
    return isHighSpeed ? CHECK_HOUSE_CONNECTION_STATUS.IsAvailable : CHECK_HOUSE_CONNECTION_STATUS.SpeedLimit;
  }
  return status;
};
export var mapResponseStatusOnStep = function mapResponseStatusOnStep(status) {
  return CHECK_HOUSE_CONNECTION_STATUS[status];
};
export var getButtonTextByStatus = function getButtonTextByStatus(status, texts) {
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, CHECK_HOUSE_CONNECTION_STATUS.HasConnectionOnAddress, texts.callbackRequest), CHECK_HOUSE_CONNECTION_STATUS.HasTicketOnAddress, texts.callbackRequest), CHECK_HOUSE_CONNECTION_STATUS.CheckAddress, texts.checkAddress), CHECK_HOUSE_CONNECTION_STATUS.NotFound, texts.callbackRequest), CHECK_HOUSE_CONNECTION_STATUS.IsAvailable, texts.isAvailable)[status] || null;
};
export var getFinalButtonTextByStatus = function getFinalButtonTextByStatus(step, texts) {
  return _defineProperty(_defineProperty({}, popupSteps.shortSuccess, texts.close), popupSteps.fail, texts.fail)[step] || null;
};